// extracted by mini-css-extract-plugin
export default {"panel":"ConsultationNotesReviewPanel_panel__k9gQ2"};